import PropTypes from "prop-types";
import { Alert, Skeleton, Stack } from "@mui/material";

import { PRICING_REPORT_SCREEN_CHART_PLOT_HEIGHT_PX } from "../../routes/pricing-reports/pricingReportPrintDimensions";

const DEFAULT_TABLE_SKELETON_ROW_COUNT = 6;
const DEFAULT_CARD_SKELETON_HEIGHT_PX = 120;

export function InsightsChartSkeleton({ height = PRICING_REPORT_SCREEN_CHART_PLOT_HEIGHT_PX, sx }) {
  return (
    <Skeleton
      variant="rounded"
      height={height}
      className="no-print"
      aria-label="Loading chart"
      sx={{ width: "100%", ...sx }}
    />
  );
}

InsightsChartSkeleton.propTypes = {
  height: PropTypes.number,
  sx: PropTypes.object,
};

export function InsightsTableSkeleton({
  rowCount = DEFAULT_TABLE_SKELETON_ROW_COUNT,
  rowHeight = 40,
  sx,
}) {
  return (
    <Stack spacing={1} aria-label="Loading table" sx={sx}>
      {Array.from({ length: rowCount }, (_, index) => (
        <Skeleton
          key={index}
          variant="rounded"
          height={rowHeight}
          className="no-print"
          sx={{ width: "100%" }}
        />
      ))}
    </Stack>
  );
}

InsightsTableSkeleton.propTypes = {
  rowCount: PropTypes.number,
  rowHeight: PropTypes.number,
  sx: PropTypes.object,
};

export function InsightsCardSkeleton({ height = DEFAULT_CARD_SKELETON_HEIGHT_PX, sx }) {
  return (
    <Skeleton
      variant="rounded"
      height={height}
      className="no-print"
      aria-label="Loading summary card"
      sx={{ width: "100%", ...sx }}
    />
  );
}

InsightsCardSkeleton.propTypes = {
  height: PropTypes.number,
  sx: PropTypes.object,
};

export function InsightsEmptyState({ message, sx }) {
  if (!message?.trim()) return null;
  return (
    <Alert severity="info" sx={{ mt: 0, ...sx }}>
      {message.trim()}
    </Alert>
  );
}

InsightsEmptyState.propTypes = {
  message: PropTypes.string,
  sx: PropTypes.object,
};

export function InsightsErrorState({
  message,
  fallbackMessage = "Something went wrong while loading data.",
  sx,
}) {
  const resolvedMessage =
    typeof message === "string"
      ? message
      : message?.message || fallbackMessage;

  return (
    <Alert severity="error" sx={{ mt: 0, ...sx }}>
      {resolvedMessage || fallbackMessage}
    </Alert>
  );
}

InsightsErrorState.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  fallbackMessage: PropTypes.string,
  sx: PropTypes.object,
};
